import { compareAsString, createArrayFromIndexedArray } from '@common/utils';
import { ZoneType } from '@common/types';
import { Zones } from '@common/types/dictionaries/zone';

export const getOnlySurveillanceZone = (zones?: Zones | null) => {
  return createArrayFromIndexedArray(zones).filter(({ Type }) => compareAsString(Type, ZoneType.Surveillance));
};
